import {FieldPropertyEnum} from "./field-property.enum";

export const textFieldProperties: string[] = [
  FieldPropertyEnum.Number2,
  FieldPropertyEnum.Desc1_1,
  FieldPropertyEnum.Desc1_2,
  FieldPropertyEnum.Desc1_3,
  FieldPropertyEnum.Desc2_1,
  FieldPropertyEnum.Desc2_2,
  FieldPropertyEnum.Desc2_3,
  FieldPropertyEnum.Text1,
  FieldPropertyEnum.Text2,
  FieldPropertyEnum.Text3
];

export const descriptionFieldProperties: string[] = [
     FieldPropertyEnum.Number1,
     FieldPropertyEnum.Number2,
     FieldPropertyEnum.Desc1_1,
     FieldPropertyEnum.Desc1_2,
     FieldPropertyEnum.Desc1_3,
     FieldPropertyEnum.Attribute,
     FieldPropertyEnum.Structure,
     FieldPropertyEnum.Desc2_1,
     FieldPropertyEnum.Desc2_2,
     FieldPropertyEnum.Desc2_3,
     FieldPropertyEnum.Text1,
     FieldPropertyEnum.Date1,
     FieldPropertyEnum.Text2,
     FieldPropertyEnum.Date2,
     FieldPropertyEnum.Text3,
     FieldPropertyEnum.Date3
];
export const executionFieldProperties: string[] = [
  FieldPropertyEnum.Company,
  FieldPropertyEnum.Craft,
  FieldPropertyEnum.Order
];
export const responsibleFieldProperties: string[] = [
  FieldPropertyEnum.ContactCO,
  FieldPropertyEnum.IsVisibleForCO,
  FieldPropertyEnum.ContactCT,
  FieldPropertyEnum.IsVisibleForCT,
  FieldPropertyEnum.ContactSC
];
export const classificationFieldProperties: string [] = [
  FieldPropertyEnum.Class1,
  FieldPropertyEnum.Class2,
  FieldPropertyEnum.Class3,
  FieldPropertyEnum.Class4
];
export const projectFieldProperties: string[] = [
  FieldPropertyEnum.UserDefined1,
  FieldPropertyEnum.UserDefined2,
  FieldPropertyEnum.Opt1,
  FieldPropertyEnum.Opt2,
  FieldPropertyEnum.Opt3,
  FieldPropertyEnum.Opt4,
  FieldPropertyEnum.Opt5,
  FieldPropertyEnum.Opt6,
  FieldPropertyEnum.Opt7,
  FieldPropertyEnum.Opt8,
  FieldPropertyEnum.Opt9
];
export const costFieldProperties : string []= [
  FieldPropertyEnum.Costs1,
  FieldPropertyEnum.Costs2,
  FieldPropertyEnum.Costs3,
  FieldPropertyEnum.Costs4,
  FieldPropertyEnum.Costs5,
  FieldPropertyEnum.CostsCompany,
  FieldPropertyEnum.CostsOrder
];

export const planFieldProperties: string[] = [
  FieldPropertyEnum.PlanId,
  FieldPropertyEnum.PlanPositionX,
  FieldPropertyEnum.PlanPositionY,
]
